import UserStore from '@stores/UserStore'
import Store from 'store'
import axios from './axios'
export const prefix = '/learn/app/'
import _ from 'lodash'
import { apiConstants } from '@const/apiConstants'
import { transform } from '@utils/intl_lang'
import { getZhiniaoPrefix } from '@utils/SSOHelper'

interface IOption {
  /** when true, not show error message */
  notShowErr?: boolean
  /** 请求开始全局loading, 结束取消loading */
  withGlobalLoading?: boolean
  headers?: any
  /** 异常处理回调函数 */
  catch?: any
}

interface IAxiosConfig {
  timeout?: number
  [x: string]: any
}

const agencyEnrollTipCode = [
  20000700,
  20000702,
  20000703,
  20000704,
  20000705,
  20000706
]
/** pre interceptor and handle error, show error message */
function preHandlePromise(
  ajaxPromise: Promise<any>,
  resolve: any,
  reject: any,
  option: IOption = {}
) {
  if (option.withGlobalLoading) {
    global.$showLoading(true)
  }
  ajaxPromise
    .then(res => {
      if (option.withGlobalLoading) {
        global.$showLoading(false)
      }
      if (+res.code === 0) {
        resolve(res)
      } else if (res.code === -4) {
        // 未登录，无需提示
        resolve({
          _failure: true,
          ...res,
        })
      } else if (agencyEnrollTipCode.includes(+res.code)) {
        // 代报名和取消代报名提示统一用code来返回不同类型状态码，无需统一提示提示
        resolve({
          _failure: false,
          ...res,
        })
      } else {
        if (!(option && option.notShowErr)) {
          // '服务错误！'
          global.$message(
            res.message || transform('humanTraining_service_error')
          )
        }
        if (typeof option.catch === 'function') {
          option.catch(res)
        }
        // reject(res);
        resolve({
          _failure: true,
          ...res,
        })
      }
    })
    .catch(err => {
      if (option.withGlobalLoading) {
        global.$showLoading(false)
      }
      const status = _.get(err, 'response.status')
      if (typeof option.catch === 'function') {
        option.catch(err)
      }
      // resolve({
      //   _fail: true,
      //   ..._.get(err, 'response.data')
      // });
      reject(_.get(err, 'response.data'))
      if (!(option && option.notShowErr)) {
        if (status >= 500 && status < 600) {
          // '服务器错误！'
          global.$message(transform('sevice_error'))
        } else if (status >= 400 && status < 500) {
          // '客户端错误！'
          global.$message(transform('client_error'))
        }
      }
    })
}

const getPrefix = (url: string) => {
  if (
    url.indexOf('http') === 0 ||
    url.indexOf('//') === 0 ||
    url.indexOf(prefix) === 0
  ) {
    return ''
  }
  return prefix
}

/** headers自带sid, appDevicePlatform */
const apiService = {
  /**
   * @param url 自动加前缀/learn/app
   * @param data 请求参数
   * @param option 可选参数
   */
  get: (
    url: string,
    data?: any,
    option: IOption = {},
    axiosConfig: IAxiosConfig = {}
  ): Promise<ISuccessModel<any>> =>
    new Promise((resolve, reject) => {
      let sid = UserStore.getSid()
      const znHost = getZhiniaoPrefix()
      // 判断是否是SaaS接口，SaaS接口用SaaS的 sid
      if (url?.indexOf(znHost) === 0) {
        const liveUserInfo = Store.get('liveUserInfo') || {}
        sid = liveUserInfo.sid
      }
      const headers = {
        sid,
        appDevicePlatform: apiConstants.STR_OS,
        ...option.headers,
        ...axiosConfig,
      }
      const ajaxPromise = axios.get(`${getPrefix(url)}${url}`, {
        params: data,
        headers,
      }) as Promise<any>
      preHandlePromise(ajaxPromise, resolve, reject, option)
    }),
  /**
   * @param url 自动加前缀/learn/app
   * @param data 请求参数
   */
  post: (
    url: string,
    data?: any,
    option: IOption = {},
    axiosConfig: IAxiosConfig = {}
  ): Promise<ISuccessModel<any>> =>
    new Promise((resolve, reject) => {
      let sid = UserStore.getSid()
      const znHost = getZhiniaoPrefix()
      // 判断是否是SaaS接口，SaaS接口用SaaS的 sid
      if (url?.indexOf(znHost) === 0) {
        const liveUserInfo = Store.get('liveUserInfo') || {}
        sid = liveUserInfo.sid
      }
      const headers = {
        'Content-Type': 'application/json;charset=UTF-8',
        sid,
        appDevicePlatform: apiConstants.STR_OS,
        ...option.headers,
      }
      const ajaxPromise = axios.post(`${getPrefix(url)}${url}`, data, {
        headers,
        ...axiosConfig,
      })
      preHandlePromise(ajaxPromise, resolve, reject, option)
    }),
}

export default apiService
